// i18n area 'auth' — locale sq-AL (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.sq-AL.meta.json.
import type { enUS } from './auth'

export const sqAL: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Hyr në llogarinë tënde',
    username: 'Emri i përdoruesit',
    usernamePlaceholder: 'Shkruaj emrin e përdoruesit',
    usernameHint: 'Përdor përdorues@domen për t’u autentikuar në një realm direktorie',
    continue: 'Vazhdo',
    changeUser: 'Nuk je ti?',
    password: 'Fjalëkalimi',
    forgotPassword: 'Harrove fjalëkalimin?',
    submit: 'Hyr',
    otp: 'Kod njëpërdorimësh',
    otpSubtitle: 'Shkruaj kodin nga autentikuesi yt',
    otpHint: 'Gjashtë shifra nga aplikacioni i autentikimit, ose një nga kodet e rikuperimit',
    otpSubmit: 'Verifiko',
    invalidCredentials: 'Emër përdoruesi ose fjalëkalim i pavlefshëm',
    tooManyAttempts: 'Shumë tentativa — prit një çast dhe riprovo',
    realmUnavailable: 'Realm-i nuk mund t’i verifikojë kredencialet në këtë moment — store-i i klasterit nuk arrihet. Hyr si përdorues lokal (break-glass).',
    genericError: 'Hyrja dështoi — a është i arritshëm backend-i TVirt?'
  },
  user: {
    logout: 'Dil',
    password: {
      menu: 'Ndrysho fjalëkalimin',
      title: 'Ndrysho fjalëkalimin tënd',
      current: 'Fjalëkalimi aktual',
      new: 'Fjalëkalimi i ri',
      confirm: 'Konfirmo fjalëkalimin e ri',
      mismatch: 'Fjalëkalimet nuk përputhen',
      error: 'Fjalëkalimi nuk mund të ndryshohej',
      forcedTitle: 'Ndrysho fjalëkalimin për të vazhduar',
      forcedHint: 'Ky fjalëkalim u vendos nga një administrator dhe duhet zëvendësuar para se të hysh.',
      forcedSubmit: 'Ndrysho dhe hyr'
    },
    mfa: {
      title: 'Autentikimi me dy faktorë',
      subtitle: 'Një faktor i dytë i kërkuar në çdo hyrje',
      loadError: 'Gjendja e faktorit të dytë nuk mund të ngarkohej',
      enrolled: 'Aktiv',
      notEnrolled: 'Joaktiv',
      enrolledAt: 'Aktivizuar më',
      codesRemaining: 'Kode rikuperimi të mbetura',
      requiredHint:
        'Një administrator kërkon faktorin e dytë në këtë llogari: konfiguroje tani — derisa ta bësh mund të hysh, por pak gjë tjetër.',
      enroll: 'Konfiguro',
      enrollTitle: 'Konfiguro autentikimin me dy faktorë',
      enrollHint: 'Skano këtë kod me aplikacionin e autentikimit, pastaj shtyp kodin që të shfaq për ta konfirmuar.',
      secretHint: 'Nuk arrin ta skanosh? Shkruaje këtë sekret në aplikacion:',
      code: 'Kodi nga aplikacioni',
      confirm: 'Konfirmo',
      startError: 'Konfigurimi nuk mund të nisej',
      confirmError: 'Konfigurimi nuk mund të konfirmohej',
      codesTitle: 'Kodet e tua të rikuperimit',
      codesWarning:
        'Këto kode shfaqen vetëm një herë. Ruaji tani: secili të fut brenda kur autentikuesi nuk është i disponueshëm, dhe secili vlen vetëm një herë.',
      codesAck: 'I kam ruajtur kodet e rikuperimit',
      codesDone: 'U bë',
      copy: 'Kopjo',
      copied: 'U kopjua',
      download: 'Shkarko',
      regenerate: 'Kode të reja rikuperimi',
      regenerateTitle: 'Rigjenero kodet e rikuperimit',
      regenerateHint: 'Të gjitha kodet e lëshuara deri tani pushojnë së funksionuari në çastin kur gjenerohet seti i ri.',
      regenerateConfirm: 'Rigjenero',
      regenerateError: 'Kodet e rikuperimit nuk mund të rigjeneroheshin',
      remove: 'Hiq',
      removeTitle: 'Hiq faktorin e dytë',
      removeConfirm: 'Hiq',
      removeHint: 'Llogaria kthehet vetëm te fjalëkalimi. Mund ta rikonfigurosh faktorin e dytë kur të duash.',
      removeRequiredHint:
        'Një administrator kërkon faktorin e dytë në këtë llogari, prandaj serveri do ta refuzojë heqjen — kërko më parë që të hiqet detyrimi.',
      removeError: 'Faktori i dytë nuk mund të hiqej'
    },
    profile: {
      menu: 'Shko te profili im',
      sessions: 'Sesionet aktive',
      sessionsHint: 'Sesionet e tua të hapura në këtë nyjë',
      sessionsEmpty: 'Asnjë sesion aktiv',
      sessionCreated: 'Hyrja u krye',
      sessionExpires: 'Skadon',
      revoke: 'Revoko sesionin',
      revokeError: 'Sesioni nuk mund të revokohej',
      loadError: 'Sesionet nuk mund të ngarkoheshin'
    }
  }
}
